/** Flex row: wordmark + BETA; gap keeps the pill clear of the horizontal logo. */
export const LOGO_BETA_WRAPPER_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '10px',
  cursor: 'pointer',
  flexWrap: 'nowrap',
};
